import React, { useState } from "react";
import "./LoginPage.css";
import NHL_logo from "../assets/NHL_logo.png";

function Login() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState({ message: "", type: "" });
  const [code, setCode] = useState("");

  const requestCode = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE}/login/request`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
        body: JSON.stringify({ email }),
      }
    );

    if (!response.ok) {
      throw new Error("Request failed");
    }

    setAlert({ message: "Could not request code", type: "error" });
  };

  const verifyCode = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/login/verify`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
          body: JSON.stringify({ email, code }),
        }
      );
      if (!response.ok) throw new Error("Verification failed");
      return response.json();
    } catch (error) {
      setAlert({ message: "Verification failed", type: "error" });
    }
  };

  const handleLogin = async () => {
    try {
      const result = await verifyCode();
      if (result?.token) {
        localStorage.setItem("token", result.token);
        setAlert({ message: "Logged in successfully.", type: "success" });
        // redirect to dashboard
        window.location.href = "/dashboard";
      } else {
        setAlert({ message: "Invalid code", type: "error" });
      }
    } catch (error) {
      setAlert({ message: "Verification failed", type: "error" });
    }
  };

  const showStep1 = () => {
    setStep(1);
    setAlert({ message: "", type: "" });
  };

  const showStep2 = async () => {
    if (!email || !email.includes("@")) {
      setAlert({
        message: "Please enter a valid email address",
        type: "error",
      });
      return;
    }

    try {
      await requestCode();
    } catch (e) {
      setAlert({ message: "Could not send the code", type: "error" });
      return;
    }

    setStep(2);
    setAlert({
      message: `Code sent successfully to ${email}`,
      type: "success",
    });
  };

  return (
    <div className="container">
      <div className="content-wrapper">
        <div className="form-container">
          <div className="logo-container">
            <img className="logo" src={NHL_logo} alt="NHL Stenden" />
          </div>

          <div className="form-card">
            {alert.message && (
              <div
                className={`alert ${
                  alert.type === "error" ? "alert-error" : "alert-success"
                }`}
              >
                <div className="alert-content">
                  <div className="icon-container">
                    <i
                      className={`fas fa-${
                        alert.type === "error"
                          ? "exclamation-circle"
                          : "check-circle"
                      }`}
                    ></i>
                  </div>
                  <div className="alert-message">
                    <p>{alert.message}</p>
                  </div>
                </div>
              </div>
            )}

            {step === 1 && (
              <div className="step-container">
                <div className="step-header">
                  <h2>Welcome Back</h2>
                  <p>Enter your email to receive a temporary login code</p>
                </div>

                <div className="input-group">
                  <label htmlFor="email">Email Address</label>
                  <div className="input-wrapper">
                    <div className="input-icon">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="name@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <button type="button" onClick={showStep2} className="button">
                  Send Code
                </button>
              </div>
            )}

            {step === 2 && (
              <div className="step-container">
                <div className="step-header">
                  <h2>Enter Code</h2>
                  <p>Enter the code sent to your email to log in</p>
                </div>

                <div className="input-group">
                  <label htmlFor="code">Temporary Code</label>
                  <div className="input-wrapper">
                    <div className="input-icon">
                      <i className="fas fa-lock"></i>
                    </div>
                    <input
                      type="text"
                      id="code"
                      name="code"
                      placeholder="Enter the code"
                      onChange={(e) => setCode(e.target.value)}
                    />
                  </div>
                </div>

                <button type="submit" onClick={handleLogin} className="button">
                  Log In
                </button>

                <div className="action-links">
                  <button
                    type="button"
                    onClick={showStep1}
                    className="back-button"
                  >
                    <i className="fas fa-arrow-left"></i> Back
                  </button>
                  <button type="button" className="resend-button">
                    Resend Code
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <p>&copy; 2024 NHL Stenden. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Login;
